import { useState } from 'react';

import { Button } from '../Button';
import { Text } from '../Text';
import { DownloadIcon, LoaderIcon } from '../../assets/icons';
import { Assets, IconNames } from '../../assets';
import { Colors } from '../../utils';

type DownloadButtonProps = {
  name: string;
  download: () => Promise<string | null>;
  rightIcon?: boolean;
  fontSize?: React.ComponentProps<typeof Button>['fontSize'];
  /** Custom color */
  color?: Colors;
  /** Custom icon */
  iconName?: IconNames;
};

export const DownloadButton = ({ name, download, fontSize, rightIcon, color, iconName }: DownloadButtonProps) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>('');

  const handleClick = async () => {
    setLoading(true);
    setError('');
    const errorText = await download();
    setError(errorText);
    setLoading(false);
  };

  return (
    <>
      <Button
        variant="primary"
        styleAs="link"
        onClick={handleClick}
        disabled={loading}
        fontSize={fontSize}
        color={loading ? 'black70' : (color ?? 'foraBlue')}
        style={{ flexDirection: rightIcon ? 'row-reverse' : 'row', columnGap: '5px' }}
      >
        {loading ? (
          <LoaderIcon width={12} containerSize={12} color="black70" />
        ) : iconName ? (
          <CustomIcon iconName={iconName} color={color} />
        ) : (
          <DownloadIcon color={color ?? 'foraBlue'} containerSize={12} width={12} />
        )}
        {name}
      </Button>
      {error && (
        <Text marginLeft={rightIcon ? 2 : 20} color="black70" size={fontSize}>
          {error}
        </Text>
      )}
    </>
  );
};

const CustomIcon = ({ iconName, color }: { color?: Colors; iconName: IconNames }) => {
  const Icon = Assets[iconName];

  return <Icon color={color ?? 'foraBlue'} containerSize={12} width={12} />;
};
